import { render, staticRenderFns } from "./order-pulls-config-grid.vue?vue&type=template&id=1268bcc6&scoped=true"
import script from "./order-pulls-config-grid.vue?vue&type=script&lang=js"
export * from "./order-pulls-config-grid.vue?vue&type=script&lang=js"
import style0 from "./order-pulls-config-grid.vue?vue&type=style&index=0&id=1268bcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268bcc6",
  null
  
)

export default component.exports